<template>
  <div class="properties-page pt-1" style="padding-top: 80px;">
    <div class="container mx-auto">
      <div class="mt-12 md:my-12 grid grid-cols-1 md:grid-cols-2 p-4">
        <div>
          <h2>Browse Properties</h2>
        </div>
        <div class="hidden md:block">
          <ul class="view-switcher">
            <li
              v-bind:class="{
                active: boxStyle,
              }"
              @click="boxStyle = true"
            >
              <font-awesome-icon :icon="['fas', 'th-large']" />
            </li>
            <li
              v-bind:class="{
                active: !boxStyle,
              }"
              @click="boxStyle = false"
            >
              <font-awesome-icon :icon="['fas', 'th-list']" />
            </li>
          </ul>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-7 lg:grid-cols-3 md:gap-6 p-4">
        <div class="md:col-span-3 lg:col-span-1">
          <div class="px-6 pt-6 border border-gray-400 rounded-lg mb-8">
            <PropertiesSearch v-model="filter" />
            <button class="btn btn-primary w-full mb-8" @click="search">
              Search
            </button>
          </div>
          <div
            class="px-6 pt-6 border border-gray-400 rounded-lg hidden md:block"
          >
            <h4 class="title mb-6">Featured Properties</h4>
            <FeaturedPropertySidebar
              class="mb-6"
              v-for="(property, index) in featuredProperties"
              :key="`featuredProperty-${index}`"
              :property="property"
            />
          </div>
        </div>
        <div class="md:col-span-4 lg:col-span-2" v-if="properties && !loading">
          <div
            class="md:col-span-4 lg:col-span-2"
            v-if="properties.length == 0"
          >
            <h4 class="title text-center my-12 md:my-64 font-bold">
              No properties were found. Please try again!
            </h4>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6" v-show="boxStyle">
            <PropertyBoxStyle
              v-for="(property, index) in properties"
              :key="`property-box-${index}`"
              :property="property"
            />
          </div>
          <div class="col-md-12 col-lg-12" v-show="!boxStyle">
            <PropertyListStyle
              v-for="(property, index) in properties"
              :key="`property-list-${index}`"
              :property="property"
            />
          </div>
          <Pagination
            v-if="propertiesPagination"
            :lastPage="propertiesPagination.last_page"
            :currentPage="propertiesPagination.current_page"
            @changePage="changePage"
          />
        </div>
        <div class="col-span-2 text-center pt-64" v-if="loading">
          <eva-icon
            class="animate-spin"
            name="loader-outline"
            height="50"
            width="50"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { FeaturedPropertySidebar } from "@/components/atoms";
import {
  PropertiesSearch,
  PropertyBoxStyle,
  PropertyListStyle,
} from "@/components/molecules";

import Pagination from "@/components/layout/Pagination";

export default {
  components: {
    Pagination,

    PropertiesSearch,
    PropertyListStyle,

    PropertyBoxStyle,
    FeaturedPropertySidebar,
  },
  data: function() {
    return {
      boxStyle: true,
      loading: true,
      filter: {},
      loadedOnce: false,
    };
  },
  computed: {
    ...mapGetters("Properties", {
      properties: "properties",
      featuredProperties: "featuredProperties",
      propertiesPagination: "propertiesPagination",
    }),
  },
  methods: {
    ...mapActions("Properties", {
      getProperties: "getProperties",
      getFeaturedProperties: "getFeaturedProperties",
    }),
    changePage: function(page) {
      this.loading = true;
      this.getProperties({
        query: this.filter,
        page: page - 1,
      }).then(() => {
        this.loading = false;
      });
      window.scrollTo(0, 0);
    },
    search: function() {
      this.changePage(1);

      this.$router.replace({
        name: "Properties",
        query: {
          ref_no: this.filter.ref_no,
          property_types:
            this.filter.property_type_id &&
            this.filter.property_type_id.length &&
            this.filter.property_type_id.join(","),
          cities:
            this.filter.city_id &&
            this.filter.city_id.length &&
            this.filter.city_id.join(","),
          price:
            this.filter.price &&
            this.filter.price.value.length &&
            this.filter.price.value.join(","),
          bedrooms: this.filter.bedrooms,
          main_bathrooms: this.filter.main_bathrooms,
          page: 1
        },
      });
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        if (!this.loadedOnce) {
          this.getProperties({
            query: this.filter,
            page: this.$route.query.page ? this.$route.query.page - 1 : 0,
          }).then(() => {
            this.loading = false;
          });
          this.loadedOnce = true;
        }
      },
    },
  },
  mounted: function() {
    if (Object.values(this.$route.query).length == 0) {
      this.getProperties({
        query: this.filter,
        page: 0,
      }).then(() => {
        this.loading = false;
      });
    }

    if (!this.featuredProperties.length) {
      this.getFeaturedProperties();
    }
  },
};
</script>

<style lang="scss" scoped>
.view-switcher {
  @apply text-right;
  li {
    @apply inline-block text-center text-base border border-gray-400 rounded-lg ml-4;

    height: 44px;
    line-height: 44px;
    width: 44px;

    &.active {
      @apply text-black bg-primary-color border-primary-color;
    }
  }
}
</style>
